import CardContentsWithInput from '@ifca-root/react-component/src/components/CardList/CardContentsWithInput'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  ListItem,
  TextField,
} from '@material-ui/core'
import BigNumber from 'bignumber.js'
import { AllocatedDialog } from 'components/Dialog/AllocatedDialog'
import { useGetApAllocationDocumentLazyQuery } from 'generated/graphql'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useEffect, useState } from 'react'
import { Controller, useWatch } from 'react-hook-form'
import NumberFormat from 'react-number-format'

interface AllocationProps {
  fields: any
  watch: any
  errors: any
  register: any
  unregister?: any
  control: any
  setValue: any
  clearErrors: any
  setError: any
  allocatedObj: any
  docAmt?: number
  setDocAmt?: (value: number) => void
  totalAmt?: number
  headerStyle?: any
  headerRightTitle?: any
  headerLeftTitle?: any
  hasAmount?: number
  hasCheckbox?: Boolean
  companyID?: string
  disabled?: boolean
}

export const PaymentAllocationTableContent = (props: AllocationProps) => {
  const {
    fields,
    watch,
    errors,
    register,
    unregister,
    control,
    setValue,
    clearErrors,
    setError,
    allocatedObj,
    docAmt,
    setDocAmt,
    totalAmt,
    headerStyle,
    headerRightTitle,
    hasCheckbox,
    headerLeftTitle,
    companyID,
    disabled,
  } = props
  const [allocDialog, setAllocDialog] = useState(false)
  const [docNo, setDocNo] = useState('')
  const [balAmt, setBalAmt] = useState('')

  const allocations = useWatch({ control, name: 'Allocation' })

  console.log(fields, 'fields in allocation')

  useEffect(() => {
    fields?.forEach((alloc, index) => {
      register(`Allocation[${index}].AllocationID`)
      hasCheckbox && register(`Allocation[${index}].IsChecked`)
      register(`Allocation[${index}].CanAllocate`)
      register(`Allocation[${index}].CreditOrDebit`)
      register(`Allocation[${index}].DocDate`)
      register(`Allocation[${index}].DocNo`)
      register(`Allocation[${index}].Description`)
      register(`Allocation[${index}].AllocationAmt`)
      register(`Allocation[${index}].BalanceAmt`)
      register(`Allocation[${index}].${alloc?.CreditOrDebit}ID`)
      register(`Allocation[${index}].${alloc?.CreditOrDebit}RefTable`)
      register(`Allocation[${index}].${alloc?.CreditOrDebit}DocNo`)

      setValue(`Allocation[${index}].AllocationID`, alloc?.AllocationID)
      hasCheckbox &&
        setValue(
          `Allocation[${index}].IsChecked`,
          alloc?.AllocationID ? true : false
        )
      setValue(`Allocation[${index}].CanAllocate`, alloc?.CanAllocate)
      setValue(`Allocation[${index}].CreditOrDebit`, alloc?.CreditOrDebit)
      setValue(`Allocation[${index}].DocDate`, alloc?.DocDate)
      setValue(`Allocation[${index}].DocNo`, alloc?.DocNo)
      setValue(`Allocation[${index}].Description`, alloc?.Description)
      setValue(
        `Allocation[${index}].AllocationAmt`,
        Number(allocatedObj[alloc[`${alloc?.CreditOrDebit}ID`]] ?? 0)
      )
      setValue(
        `Allocation[${index}].BalanceAmt`,
        Number(alloc?.BalanceAmt ?? 0)
      )
      setValue(
        `Allocation[${index}].${alloc?.CreditOrDebit}ID`,
        alloc[`${alloc?.CreditOrDebit}ID`]
      )
      setValue(
        `Allocation[${index}].${alloc?.CreditOrDebit}RefTable`,
        alloc[`${alloc?.CreditOrDebit}RefTable`]
      )
      setValue(
        `Allocation[${index}].${alloc?.CreditOrDebit}DocNo`,
        alloc[`${alloc?.CreditOrDebit}DocNo`]
      )
    })
  }, [fields, allocatedObj])

  useEffect(() => {
    if (!allocations || !Array.isArray(allocations)) return
    let totalCredit = 0
    let totalDebit = 0
    allocations.forEach(alloc => {
      if (alloc?.IsChecked) {
        const amt = Number(alloc?.AllocationAmt || 0)
        if (alloc?.CreditOrDebit === 'Credit') totalCredit += amt
        if (alloc?.CreditOrDebit === 'Debit') totalDebit += amt
      }
    })
    setDocAmt?.(totalCredit - totalDebit)
  }, [allocations])

  const handleCheckboxChange = (alloc, index) => {
    const allocationPath = `Allocation[${index}]`
    const isChecked = watch(`${allocationPath}.IsChecked`)
    const newChecked = !isChecked

    setValue(`${allocationPath}.IsChecked`, newChecked)

    if (newChecked) {
      const newValue = allocatedObj[alloc[`${alloc?.CreditOrDebit}ID`]]
      setValue(`${allocationPath}.AllocationAmt`, alloc?.BalanceAmt ?? newValue)
    } else {
      setValue(`${allocationPath}.AllocationAmt`, 0)
    }
  }

  const [
    loadAllocationDocument,
    { data: { getAllocationDocument } = { getAllocationDocument: [] } },
  ] = useGetApAllocationDocumentLazyQuery({
    fetchPolicy: 'network-only',
    onError: error => console.log('ERROR', error),
  })
  return (
    <>
      <CardContentsWithInput
        IsDifferentColour={true}
        //IsBold={true}
        headerDifferentColour
        section={{
          header: {
            title: headerLeftTitle ?? 'Document',
            rightTitle: headerRightTitle ?? amtStr(docAmt),

            // docAmt: docAmt,
            // totalAmt: totalAmt,
            error: totalAmt && docAmt && totalAmt > docAmt ? true : false,
            errorMsg: docAmt < 0 ? 'Amount cannot be negative' : null,
            style: headerStyle
              ? headerStyle
              : {
                  backgroundColor: '#e9e9e9',
                  color: '#000000',
                  fontWeight: '700',
                },
          },
        }}
        style={{ padding: 'initial' }}
      >
        <div className="table-wrap rm-padding">
          {fields?.length > 0 ? (
            watch('Allocation')?.map((alloc, index) => {
              const allocation = `Allocation[${index}]`

              let balanceAmt
              balanceAmt =
                alloc?.AllocationID &&
                parseFloat(fields[index]?.AllocationAmt) >
                  Number(alloc?.BalanceAmt)
                  ? fields[index]?.AllocationAmt + Number(alloc?.BalanceAmt)
                  : (Number(alloc?.BalanceAmt) ??
                    parseFloat(fields[index]?.AllocationAmt))

              return (
                <>
                  <ListItem
                    key={index}
                    style={{ paddingRight: '0px', paddingLeft: '12px' }}
                  >
                    {hasCheckbox && (
                      <FormControl
                        component="fieldset"
                        style={{ width: '24px' }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              value={alloc?.[`${alloc?.CreditOrDebit}ID`]}
                              onChange={() =>
                                handleCheckboxChange(alloc, index)
                              }
                              checked={watch(`${allocation}.IsChecked`)}
                              disabled={
                                (disabled &&
                                  alloc?.DebitRefTable === 'AP_CreditNote') ||
                                (disabled &&
                                  alloc?.DebitRefTable ===
                                    'AP_CreditorCreditNote')
                              }
                              color="primary"
                            />
                          }
                          label=""
                          name="check"
                        />
                      </FormControl>
                    )}
                    <Grid
                      // spacing={1}
                      container
                      className="table-content"
                      key={alloc?.id}
                      style={{ padding: '8px 12px 4px 8px' }}
                    >
                      <Grid
                        item
                        xs={7}
                        style={{
                          placeSelf: 'start',
                        }}
                      >
                        <div
                          className="desc text-noflow"
                          style={{ lineBreak: 'anywhere', lineHeight: '20px' }}
                        >
                          <div>
                            <span className="mdDesc flex-space">
                              {formatDate(alloc?.DocDate)}
                            </span>

                            <span
                              className="mdDesc click-text"
                              style={{ marginLeft: '15px', fontWeight: 700 }}
                              onClick={() => {
                                setDocNo(
                                  alloc?.[`${alloc?.CreditOrDebit}DocNo`]
                                )
                                setBalAmt(amtStr(balanceAmt))
                                setAllocDialog(true)
                                loadAllocationDocument({
                                  variables: {
                                    entityID:
                                      alloc?.[`${alloc?.CreditOrDebit}ID`],
                                    companyID: companyID,
                                    refTable:
                                      alloc?.[
                                        `${alloc?.CreditOrDebit}RefTable`
                                      ],
                                    creditorDebtorID:
                                      watch('CreditorAccountID'),
                                  },
                                })
                              }}
                            >
                              {alloc?.[`${alloc?.CreditOrDebit}DocNo`]}
                            </span>
                          </div>
                          <div>
                            <span
                              className="desc flex-space"
                              style={{
                                whiteSpace: 'initial',
                                display: 'inline-block',
                                color: 'grey',
                              }}
                            >
                              {alloc?.Description}
                            </span>
                          </div>
                        </div>
                      </Grid>

                      <Grid
                        item
                        xs={5}
                        style={{
                          placeSelf: 'start',
                          marginRight: 'auto',
                          textAlign: 'right',
                          flexWrap: 'wrap',
                          display: 'flex',
                          justifyContent: 'end',
                        }}
                      >
                        <div
                          className="desc text-noflow"
                          style={{ lineBreak: 'anywhere', lineHeight: '20px' }}
                        >
                          <div>
                            <span
                              className="mdDesc"
                              style={{ fontWeight: 500 }}
                            >
                              {`O/S: ${
                                alloc?.CreditOrDebit === 'Credit'
                                  ? amtStr(balanceAmt)
                                  : `(${amtStr(balanceAmt)} )`
                              }`}
                            </span>
                          </div>

                          {hasCheckbox ? (
                            watch(`${allocation}.IsChecked`) && (
                              <div>
                                <span
                                  className="mdDesc alloc-amt-input"
                                  style={{ height: '10px' }}
                                >
                                  <Controller
                                    ref={register}
                                    name={`${allocation}.AllocationAmt`}
                                    control={control}
                                    required
                                    defaultValue={
                                      allocatedObj[
                                        alloc[`${alloc?.CreditOrDebit}ID`]
                                      ] ?? watch(`${allocation}.AllocationAmt`)
                                    }
                                    render={({ onChange, onBlur, value }) => (
                                      <NumberFormat
                                        thousandSeparator
                                        // disabled={
                                        //   disableAllocation ||
                                        //   alloc?.DebitRefTable === 'AP_Advance'
                                        // }
                                        allowNegative={false}
                                        defaultValue={
                                          allocatedObj[
                                            alloc[`${alloc?.CreditOrDebit}ID`]
                                          ] ??
                                          watch(`${allocation}.AllocationAmt`)
                                        }
                                        customInput={TextField}
                                        className="p-l-10 round-input"
                                        name={`${allocation}.AllocationAmt`}
                                        required
                                        variant="outlined"
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        onValueChange={values => {
                                          let { floatValue } = values
                                          register(
                                            `${allocation}.AllocationAmt`
                                          )
                                          setValue(
                                            `${allocation}.AllocationAmt`,
                                            floatValue
                                          )
                                          if (
                                            (!alloc?.AllocationID &&
                                              floatValue > alloc?.BalanceAmt) ||
                                            (alloc?.AllocationID &&
                                              floatValue > balanceAmt)
                                          ) {
                                            setError(
                                              `${allocation}.AllocationAmt`,
                                              {
                                                message:
                                                  'Cannot exceed balance',
                                              }
                                            )
                                          } else {
                                            clearErrors(
                                              `${allocation}.AllocationAmt`
                                            )
                                          }
                                        }}
                                        helperText={
                                          errors.Allocation &&
                                          errors.Allocation[index]
                                            ?.AllocationAmt
                                            ? errors.Allocation[index]
                                                ?.AllocationAmt?.message
                                            : null
                                        }
                                        error={
                                          errors.Allocation &&
                                          errors.Allocation[index]
                                            ?.AllocationAmt
                                        }
                                      />
                                    )}
                                  />
                                </span>
                              </div>
                            )
                          ) : (
                            <span
                              className="mdDesc alloc-amt-input"
                              style={{ height: '10px' }}
                            >
                              <Controller
                                ref={register}
                                name={`${allocation}.AllocationAmt`}
                                control={control}
                                required
                                defaultValue={
                                  allocatedObj[
                                    alloc[`${alloc?.CreditOrDebit}ID`]
                                  ] ?? 0
                                }
                                render={({ onChange, onBlur, value }) => (
                                  <NumberFormat
                                    thousandSeparator
                                    // disabled={disableAllocation}
                                    allowNegative={false}
                                    defaultValue={
                                      allocatedObj[
                                        alloc[`${alloc?.CreditOrDebit}ID`]
                                      ] ?? 0
                                    }
                                    customInput={TextField}
                                    className="p-l-10 round-input"
                                    name={`${allocation}.AllocationAmt`}
                                    required
                                    variant="outlined"
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    onValueChange={values => {
                                      let { floatValue } = values
                                      register(`${allocation}.AllocationAmt`)
                                      setValue(
                                        `${allocation}.AllocationAmt`,
                                        floatValue
                                      )
                                      if (floatValue > alloc?.BalanceAmt) {
                                        setError(
                                          `${allocation}.AllocationAmt`,
                                          {
                                            message: 'Cannot exceed balance',
                                          }
                                        )
                                      } else {
                                        clearErrors(
                                          `${allocation}.AllocationAmt`
                                        )
                                      }
                                    }}
                                    helperText={
                                      errors.Allocation &&
                                      errors.Allocation[index]?.AllocationAmt
                                        ? errors.Allocation[index]
                                            ?.AllocationAmt?.message
                                        : null
                                    }
                                    error={
                                      errors.Allocation &&
                                      errors.Allocation[index]?.AllocationAmt
                                    }
                                  />
                                )}
                              />
                            </span>
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </ListItem>
                  {index !== fields?.length - 1 && (
                    <Divider
                      variant="fullWidth"
                      style={{ background: '#E4E4E4' }}
                    ></Divider>
                  )}
                </>
              )
            })
          ) : (
            <EmptyList title="No Record found" />
          )}
        </div>
      </CardContentsWithInput>
      <AllocatedDialog
        allocDialog={allocDialog}
        setAllocDialog={setAllocDialog}
        docNo={docNo}
        BalAmt={balAmt}
        allocatedArr={getAllocationDocument}
      />
    </>
  )
}
